import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useFSEBillContentStyles = makeStyles({
  cellLeft: {
    alignItems: 'center',
    display: 'flex'
  },
  cellInput: {
    marginRight: '25px',
    width: '100%'
  },
  cellRight: {
    justifyContent: 'flex-end'
  },
  summaryBlock: {
    '& + &': {
      marginLeft: '24px',
      paddingLeft: '24px',
      borderLeft: "1px solid ".concat(palette.shades[300])
    }
  },
  summaryBlocks: {
    display: 'flex',
    alignContent: 'center'
  },
  summaryWrapper: {
    margin: '18px 32px'
  },
  statementRow: {
    border: '1px solid #e0e0e0',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '18px 16px'
  },
  topSectionWrapper: {
    boxShadow: palette.shadows.light,
    position: 'relative',
    minHeight: '48px'
  },
  totalBlock: {
    alignItems: 'end',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    padding: '18px 16px'
  }
});
export default useFSEBillContentStyles;